import * as Sentry from '@sentry/react';
import { appVersion } from '@/lib/version';

export type SupportCategory = 'BUG' | 'SUGGESTION' | 'QUESTION';

export const SUPPORT_CATEGORY_LABELS: Record<SupportCategory, { title: string; hint: string }> = {
  BUG: { title: 'Encontrei um problema', hint: 'Conte brevemente o que você estava tentando fazer' },
  SUGGESTION: { title: 'Tenho uma sugestão', hint: 'Conte brevemente o que você gostaria de ver no soupelvi' },
  QUESTION: { title: 'Dúvida / Falar com suporte', hint: 'Conte brevemente qual é a sua dúvida' },
};

export interface SupportContext {
  route: string;
  url: string;
  userAgent: string;
  appVersion: string;
  occurredAt: string;
}

export interface SupportCapture {
  context: SupportContext;
  sentryEventId: string | null;
}

/** Coleta o contexto técnico no momento do envio. O Sentry só entra em BUG e só se já houver evento. */
export function captureSupportContext(category: SupportCategory): SupportCapture {
  return {
    context: {
      route: window.location.pathname,
      url: window.location.href,
      userAgent: navigator.userAgent,
      appVersion,
      occurredAt: new Date().toISOString(),
    },
    sentryEventId: category === 'BUG' ? (Sentry.lastEventId() ?? null) : null,
  };
}
